// Import styles first (side effect - auto-loads on @peanuds/ui import)
import './styles/main.css';

import en from './locales/en.json';
import de from './locales/de.json';

export const uiLocales = {
  en: { ui: en },
  de: { ui: de },
};

export { manualEntryAttributes } from './manual-entry-attributes';
export { overlaySuspendedKey } from './overlay-suspended';

// Export Vue components as named exports (SFCs have default exports)
export { default as AddMoneyCard } from './components/AddMoneyCard.vue';
export { default as SharePopover } from './components/SharePopover.vue';
export { default as UiRowActionsMenu } from './components/UiRowActionsMenu.vue';
export * from './components';

// Export composables (these use named exports)
export * from './components/useSharePopover';

// Export asset URLs
export {
  currencyIcons,
  euroIcon,
  usdIcon,
  gbrIcon,
  cnhIcon,
  cardOutIcon,
  outIcon,
  inIcon,
  accountsEuroIcon,
  accountsUsdIcon,
  accountsGbrIcon,
} from './assets/currency-icons';

// Export all icon components (organized namespace + individual exports)
export * from './assets/icons';
